import {
  FETCH_STATIONS,
  FETCH_STATIONS_FAILURE,
  FETCH_STATIONS_SUCCESS,
  FETCH_STATIONS_TO,
  FETCH_STATIONS_TO_FAILURE,
  FETCH_STATIONS_TO_SUCCESS,
} from './constants';

const connectionInitialState = {
  stations: [],
  error: null,
  isFetching: false,
};

const enterStationsReducer = (state = connectionInitialState, action) => {
  switch (action.type) {
    case FETCH_STATIONS:
      return { ...state, isFetching: true };
    case FETCH_STATIONS_SUCCESS:
      return {
        ...state,
        stations: [...action.payload.stations],
        error: null,
        isFetching: false,
      };
    case FETCH_STATIONS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    default:
      return state;
  }
};

export const finalStationReducer = (state = connectionInitialState, action) => {
  switch (action.type) {
    case FETCH_STATIONS_TO:
      return { ...state, isFetching: true };
    case FETCH_STATIONS_TO_SUCCESS:
      return {
        ...state,
        byFromStationId: {
          ...state.byId,
          [action.id]: [...action.payload.stations],
        },
        selected: action.id,
        error: null,
        isFetching: false,
      };
    case FETCH_STATIONS_TO_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    default:
      return state;
  }
};

export default enterStationsReducer;



// WEBPACK FOOTER //
// ./src/containers/ConnectionForm/reducer.js